import React, { useRef } from "react";

import { Map } from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer } from "react-leaflet";
import "./DevicesMap.scss";
import MapContent from "./map-content/MapContent";

const DevicesMap = () => {
    const mapRef = useRef<Map | null>(null);
    return (
      <div className="relative">
        <MapContainer
          id="map"
          scrollWheelZoom
          doubleClickZoom={false}
          zoomControl={false}
          ref={mapRef}
          maxZoom={18}
          minZoom={5}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"

          />
          <MapContent />
        </MapContainer>
      </div>
    );
};

export default DevicesMap;
